import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ElmFleetInfo } from '@features/fleets/models/elm-fleet-info';
import { TruckPlateNumberDetails } from '@features/fleets/models/plate-number-details.model';

@Component({
  selector: 'app-truck-elm-data-modal',
  templateUrl: './truck-elm-data-modal.component.html',
  styleUrls: ['./truck-elm-data-modal.component.scss'],
})
export class TruckElmDataModalComponent implements OnInit {
  @Input() data: ElmFleetInfo;
  @Input() plateNumberDetails = new TruckPlateNumberDetails();
  @Output() confirmed = new EventEmitter();

  constructor() {}

  ngOnInit(): void {}
}
